<template>
  <span>
    <span class="mode-btn-box">
      <span
        v-show="
          receiverUserInfo &&
          receiverUserInfo.userId != null &&
          receiverUserInfo.userId > 0
        "
        class="primary cur"
        @click="showBankAccount(receiverUserInfo)"
        >银行账户</span
      >
    </span>
    <el-dialog
      title="银行账户"
      :lock-scroll="true"
      :visible.sync="dialogFormVisible"
      width="800px"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <section class="dialogContent">
        <qx-detail-box
          v-for="(data, index) in detailData"
          :data="data"
          :key="index"
        />
        <TableBox ref="tableBox" />
      </section>
      <section slot="footer" class="dialog-footer">
        <el-button @click="hide">取 消</el-button>
        <el-button type="primary" @click="hide" :loading="subLoading"
          >确定</el-button
        >
      </section>
    </el-dialog>
  </span>
</template>

<script>
import TableBox from './tableBox';
export default {
  model: {
    prop: 'receiverUserInfo',
    event: 'cc',
  },
  components: {
    TableBox,
  },
  props: {
    receiverUserInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      dialogFormVisible: false,
      subLoading: false,
      detailData: {
        base: {
          label: '银行账户信息',
          tableData: {
            title: [
              { prop: 'linkman', label: '收款人' },
              { prop: 'mobilePhone', label: '收款电话' },
            ],
            data: {},
            approveData: {},
          },
        },
      },
    };
  },
  methods: {
    show () {
      this.dialogFormVisible = true;
    },
    hide () {
      this.dialogFormVisible = false;
    },
    showBankAccount (item) {
      this.show();
      this.$nextTick(() => {
        this.$refs.tableBox.saveSearchBoxData({
          userId: item.userId,
          userType: item.userType || 7,
        });
        this.detailData.base.tableData.data = {
          linkman: item.linkman,
          mobilePhone: item.mobilePhone,
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.mode-btn-box {
  margin-left: 16px;
}
</style>
